import { adminCategoriesApi } from './admin-categories-api';
import { adminCourseApi } from './admin-course-api';
import { adminDebtorsApi } from './admin-debtors-api';
import { adminFundsApi } from './admin-funds-api';
import { adminNotificationsApi } from './admin-notifications-api';
import { adminPaymentDocumentApi } from './admin-payment-document-api';
import { adminReportApi } from './admin-report-api';
import { adminUserFundsApi } from './admin-user-funds-api';
import { authenticationApi } from './authentication-api';
import { bankAccountsApi } from './bank-accounts-api';
import { captchaApi } from './captcha-api';
import { categoriesApi } from './categories-api';
import { courseApi } from './course-api';
import { dashboardApi } from './dashboard-api';
import { driveApi } from './drive-api';
import { homeApi } from './home-api';
import { notificationsApi } from './notifications-api';
import { PaymentDocumentApi } from './payment-document-api';
import { profileApi } from './profile-api';
import { tilesApi } from './tiles-api';
import { userfundsApi } from './user-funds-api';
import { userValidationsApi } from './user-validation-api';
import { usersApi } from './users-api';

export const Api = {
  adminCategoriesApi: adminCategoriesApi,
  adminPaymentDocumentApi: adminPaymentDocumentApi,
  userValidationsApi: userValidationsApi,
  adminCourseApi: adminCourseApi,
  authenticationApi: authenticationApi,
  adminNotificationsApi: adminNotificationsApi,
  captchaApi: captchaApi,
  categoriesApi: categoriesApi,
  courseApi: courseApi,
  dashboardApi: dashboardApi,
  driveApi: driveApi,
  homeApi: homeApi,
  profileApi: profileApi,
  tilesApi: tilesApi,
  usersApi: usersApi,
  notificationsApi: notificationsApi,
  bankAccountsApi: bankAccountsApi,
  adminFundsApi: adminFundsApi,
  adminUserFundsApi: adminUserFundsApi,
  userfundsApi: userfundsApi,
  PaymentDocumentApi: PaymentDocumentApi,
  adminReportApi: adminReportApi,
  adminDebtorsApi: adminDebtorsApi,
};
